import React from 'react';

import { Button, Form } from 'react-bootstrap';
import type { SearchBoxProvided } from 'react-instantsearch-core';
import { connectSearchBox } from 'react-instantsearch-dom';

import styles from './TextSearch.module.scss';

export const TextSearchInner: React.FC<SearchBoxProvided> = ({
  refine,
  currentRefinement,
}) => {
  return (
    <Form onSubmit={(e) => e.preventDefault()} role="search" action="">
      <Form.Group>
        <Form.Label className={styles.label} htmlFor="search">
          Search
        </Form.Label>
        <Form.Control
          name="search"
          placeholder="Search..."
          onChange={(e) => refine(e.target.value)}
          defaultValue={currentRefinement}
          type="search"
          autoFocus
          id="search"
        />
        <Button
          variant="primary"
          type="submit"
          className="d-none"
          value="Search"
        />
      </Form.Group>
    </Form>
  );
};

const TextSearch = connectSearchBox(TextSearchInner);
export default TextSearch;
